import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Dashboard = props => {
  //meta title
  document.title = "Dashboard";
  const dispatch = useDispatch();
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();

  const [modal_Fiat_Transaction, setmodal_Fiat_Transaction] = useState(false);
  function Fiat_Transaction() {
    setmodal_Fiat_Transaction(!modal_Fiat_Transaction);
    // removeBodyCss();
  }

  const [modal_Crypto_Transaction, setmodal_Crypto_Transaction] = useState(false);
  function Crypto_Transaction() {
    setmodal_Crypto_Transaction(!modal_Crypto_Transaction);
    // removeBodyCss();
  }



  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [ DashboardNumbers, setDashboardNumbers ] = React.useState({});
  const handleLoadGetDashboardNumbers = async () => {
    const res = await getRequest('get-dashboard-numbers');
    if (res && res.code === 200) {
      setDashboardNumbers(res.data);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const [FilePath, setFilePath] = React.useState('');
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.pct_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.token}</td>
        <td>{element.currency}</td>
        <td>{parseFloat(element.received_amount)} &nbsp;{element.currency}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <span className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></span>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-property-crypto-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data.transaction);
      setFilePath(res.data.url);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="10" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
    const [company, setCompany] = useState(0);
    const [contract, setContract] = useState(0);
    const [jha, setJha] = useState(0);
    const [job, setJob] = useState(0);
    const [userType, setUserType] = useState("");
      const fetchUserType = async () => {
        const res = await getRequest("get-admin-info");
        if (res && res.code === 200) {
          setUserType(res.data.type);
        }
      };


    const handleLoadGetDashboardCount = async () => {
    const jsonpar = JSON.stringify({
      selected_organization: "all"
    });
    const res = await postRequest('get-dashboard-count', jsonpar);
    if (res && res.code === 200) {
      const companyfilteredData = res.data.companyData.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));
      const contractfilteredData = res.data.contractData.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));
      const jobfilteredData = res.data.jobData.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));
      const jhafilteredData = res.data.jhaData.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));

      setCompany(companyfilteredData.length)
      setContract(contractfilteredData.length)
      setJha(jhafilteredData.length)
      setJob(jobfilteredData.length)
    }
  }
  React.useEffect(() => {
    fetchUserType();
    handleLoadGetDashboardCount();
    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      window.history.replaceState({}, document.title);
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Dashboard")} />
          <Row>
            <Col xs="12">
              <Row>
                {/* <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Crew Members</h5>
                          <h4 className="mb-0">4</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-check display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col> */}
                {userType === 'admin' && (
                  <>
                    <Col lg="3" md="6">
                      <Card>
                        <CardBody className="pb-3">
                          <Link to="#" className="d-flex flex-wrap">
                            <div>
                              <h5 className="card-title mb-3 me-2">Company</h5>
                              <h4 className="mb-0">{company}</h4>
                            </div>
                            <div className="ms-auto align-self-end">
                              <i className="bx bx-user display-4 text-light"></i>
                            </div>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="3" md="6">
                      <Card>
                        <CardBody className="pb-3">
                          <Link to="#" className="d-flex flex-wrap">
                            <div>
                              <h5 className="card-title mb-3 me-2">Contract</h5>
                              <h4 className="mb-0">{contract}</h4>
                            </div>
                            <div className="ms-auto align-self-end">
                              <i className="bx bx-transfer-alt display-4 text-light"></i>
                            </div>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="3" md="6">
                      <Card>
                        <CardBody className="pb-3">
                          <Link to="#" className="d-flex flex-wrap">
                            <div>
                              <h5 className="card-title mb-3 me-2">Job Types</h5>
                              <h4 className="mb-0">{job}</h4>
                            </div>
                            <div className="ms-auto align-self-end">
                              <i className="bx bx-list-ul display-4 text-light"></i>
                            </div>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                  </>
                )}
                

                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="#" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">JHA</h5>
                          <h4 className="mb-0">{jha}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-list-ul display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                
              </Row>
            </Col>
          </Row>




        </Container>
      </div>

    </React.Fragment >
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
